import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_PUBLISHER: (name, status) => ({ name, status }),
    API: {
      ADD_PUBLISHER: apiResourceActionCreator('publisher')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/add-publisher`, authToken, payload, actions.admin.api.addPublisher);

function* addPublisher(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.addPublisher);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.publishers }));
  }
}

const configuration = {
  name: 'addPublisher',
  action: actions,
  sagas: addPublisher,
  reducers: {
    request: (state, action) => ({
      ...state,
      isPostingPublisher: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isPostingPublisher: false,
      lastAddedPublisher: action.payload.publisher,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isPostingPublisher: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addPublisher.js